module.exports = __webpack_public_path__ + "static/media/dragon.832e6a35.mp4";